exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h2 {\r\n  margin-top: 200px;\r\n  text-align: center;\r\n  color: #ffffff;\r\n}\r\n\r\n.container{\r\n  height: 700px;\r\n}\r\nh1{\r\n  color: #C51162;\r\n  margin-top: 10px;\r\n  text-align: center;\r\n  font-size: x-large;\r\n}\r\n\r\n\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/neron/Documents/coo/coo/coo-V3/src/app/page-not-found/page-not-found.component.css
// module id = ../../../../../src/app/page-not-found/page-not-found.component.css
// module chunks = main